"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportPhoto = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var store_1 = require("../../../store");
var ImageWithTitle_1 = require("../components/ImageWithTitle");
var TitleBar_1 = require("../components/TitleBar");
var ReportHelpers_1 = require("../ReportHelpers");
var ReportBase_1 = require("./ReportBase");
var ReportPhoto = /** @class */ (function (_super) {
    tslib_1.__extends(ReportPhoto, _super);
    function ReportPhoto(poles) {
        return _super.call(this, poles) || this;
    }
    ReportPhoto.prototype.buildPDF = function () {
        var _this = this;
        this.poles.forEach(function (pole, i) {
            var job = store_1.AppStore.Tag.get(pole.jobId);
            // Title
            var poletitle = (new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, _this.poles.length));
            var isFirstCaptureForPole = true;
            pole.forEachField(function (field) {
                // Normal and True Size images
                if (field instanceof core_shared_1.CollectionModelFieldTrueSize ||
                    field instanceof core_shared_1.CollectionModelFieldImage) {
                    var captures = field.getCaptures();
                    captures.forEach(function (capture, j) {
                        if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                            var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                            _this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                            var imgReference = { reference: imageReferenceString };
                            // If the image doesnt have any measurements, attach the timestamp to the image
                            if (!(0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                imgReference.timeStamp = new Date(capture.createdAt);
                            }
                            _this.nodes.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, imgReference, { sectionTitle: isFirstCaptureForPole ? poletitle : undefined, pageBreak: i === 0 && isFirstCaptureForPole ? 'none' : 'before' }));
                            isFirstCaptureForPole = false;
                        }
                    });
                }
            });
        });
    };
    return ReportPhoto;
}(ReportBase_1.ReportBase));
exports.ReportPhoto = ReportPhoto;
//# sourceMappingURL=ReportPhoto.js.map